import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { GraduationCap } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";

export default function ResetPassword() {
  const { resetPassword } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const token = new URLSearchParams(location.search).get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!token) { toast.error("Missing reset token"); return; }
    if (password.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    if (password !== confirm) { toast.error("Passwords do not match"); return; }
    try {
      await resetPassword(token, password);
      toast.success("Password updated! Please sign in.");
      navigate("/login");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not reset password");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="w-full max-w-md bg-white rounded-2xl border border-gray-100 p-8 shadow-sm">
        <div className="flex items-center gap-2.5 mb-6">
          <span className="w-10 h-10 rounded-xl bg-teal flex items-center justify-center"><GraduationCap className="w-5 h-5 text-white" /></span>
          <span className="font-head font-extrabold text-2xl">Studio V</span>
        </div>
        <h2 className="font-head text-2xl font-bold tracking-tight">Set a new password</h2>
        <p className="text-muted-foreground mt-1.5 text-sm">Choose a new password for your account.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div><label className="text-sm font-semibold">New password</label><Input data-testid="reset-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 rounded-xl bg-white" /></div>
          <div><label className="text-sm font-semibold">Confirm password</label><Input data-testid="reset-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1.5 rounded-xl bg-white" /></div>
          <button type="submit" data-testid="reset-submit" className="w-full bg-teal hover:bg-teal-dark text-white rounded-full py-3.5 font-semibold transition-colors duration-200">Update password</button>
        </form>
      </div>
    </div>
  );
}
